"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfig = void 0;
var env_config_1 = require("./env.config");
exports.envConfig = env_config_1.default;
